// extracted by mini-css-extract-plugin
export var conversationListItem = "_wt-2";
export var fullBleedList = "_wt-3";
export var messageText = "_wt-1";
export var previewText = "_wt-0";